import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function slugify(value: string) {
  return value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)+/g, "");
}

export function formatDate(date?: Date | string | null) {
  if (!date) return "Nincs datum";
  return new Intl.DateTimeFormat("hu-HU", {
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(date));
}

export function formatBudapestDateTime(date?: Date | string | null) {
  if (!date) return "Nincs datum";
  return new Intl.DateTimeFormat("hu-HU", {
    timeZone: "Europe/Budapest",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(date));
}

export function readingTime(content: string) {
  const words = content.trim().split(/\s+/).filter(Boolean).length;
  return Math.max(1, Math.ceil(words / 210));
}

const FLAG_BY_NATIONALITY: Record<string, string> = {
  argentina: "AR",
  belgium: "BE",
  brazil: "BR",
  croatia: "HR",
  denmark: "DK",
  england: "GB",
  france: "FR",
  germany: "DE",
  ghana: "GH",
  hungary: "HU",
  italy: "IT",
  japan: "JP",
  morocco: "MA",
  netherlands: "NL",
  nigeria: "NG",
  norway: "NO",
  poland: "PL",
  portugal: "PT",
  scotland: "GB",
  serbia: "RS",
  slovakia: "SK",
  slovenia: "SI",
  "south korea": "KR",
  spain: "ES",
  sweden: "SE",
  switzerland: "CH",
  turkey: "TR",
  ukraine: "UA",
  "united states": "US",
  uruguay: "UY",
  wales: "GB",
};

export function initialsFromName(name: string) {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? "")
    .join("");
}

export function flagEmojiFromNationality(nationality: string | null | undefined) {
  if (!nationality) return null;
  const code = FLAG_BY_NATIONALITY[nationality.trim().toLowerCase()];
  if (!code) return null;

  return code
    .toUpperCase()
    .split("")
    .map((char) => String.fromCodePoint(127397 + char.charCodeAt(0)))
    .join("");
}
